import { Model, View } from '@lernetz/ts-lib';

import { Topic } from './Topic';

import topicsPreviewTemplate from './TopicsPreview.html';


export class TopicsPreview extends Model {

    public readonly hash: string;
    public readonly topics: Topic[];
    public readonly marginTop: string;
    public readonly marginBottom: string;

    constructor(dto) {
        super();
        this.hash = dto.hash;
        this.topics = dto.topics || [];
        this.marginTop = dto.marginTop || '';
        this.marginBottom = dto.marginBottom || '';
    }
}


export class TopicsPreviewView extends View<TopicsPreview> {

    constructor() {
        super({ template: topicsPreviewTemplate });
    }
}
